;(() => {
  const modal = document.querySelector('section#modal')
  const html = document.querySelector('html')
  document
    .querySelectorAll('section.videos button.block-video')
    .forEach((video) => {
      video.addEventListener('click', () => {
        modal.classList.add('active', 'iframe')
        html.classList.add('modal-open')
        document.querySelector('section#modal main.wrapper').innerHTML =
          video.querySelector('.video-modal-content').innerHTML
      })
    })
})()
